// React (Frontend)
import React, { useState, useEffect } from "react";

function App() {
  const [files, setFiles] = useState([]);
  const [uploadPath, setUploadPath] = useState("/");
  const [selectedFiles, setSelectedFiles] = useState(null);

  useEffect(() => {
    fetchFiles();
  }, [uploadPath]);

  const fetchFiles = async () => {
    const response = await fetch(`/api/fileManager/files?path=${encodeURIComponent(uploadPath)}`);
    const data = await response.json();
    setFiles(data);
  };

  const handleFileSelect = (event) => {
    setSelectedFiles(event.target.files);
  };

  const handleFileUpload = async () => {
    if (!selectedFiles) return;

    const formData = new FormData();
    for (const file of selectedFiles) {
      formData.append("files", file);
    }
    formData.append("path", uploadPath);

    await fetch("/api/fileManager/upload", {
      method: "POST",
      body: formData,
    });
    fetchFiles();
  };

  const handlePathChange = (path) => {
    setUploadPath(path);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <div style={{ flex: 1, padding: "10px", borderBottom: "1px solid #ccc" }}>
        <h3>Upload Files</h3>
        <input type="file" multiple onChange={handleFileSelect} />
        <button onClick={handleFileUpload} disabled={!selectedFiles}>Upload</button>
      </div>
      <div style={{ flex: 1, padding: "10px", overflowY: "scroll" }}>
        <h3>File Directory</h3>
        <ul>
          {files.map((file) => (
            <li key={file.name} onClick={() => file.isDir && handlePathChange(file.path)}>
              {file.isDir ? `[Dir] ${file.name}` : file.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default App;